import { useMemo } from 'react'

import { ListingEntity } from '@eastcoal/api/trade/interface'
import { queryListingPageApi } from '@eastcoal/api/trade/listingMember/queryListingPage'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { toArray } from '@eastcoal/common/utils/array'
import { pick } from '@eastcoal/common/utils/object'

import { DateRangePicker } from '@eastcoal/formily/components/DatePicker'
import { Input } from '@eastcoal/formily/components/Input'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { useListingPickerStore } from '../Store/hooks/useStore'

import { ListingTableProps } from './interface'

const columns: ListingTableProps['columns'] = [
  {
    title: 'ID',
    dataIndex: 'code'
  },
  {
    title: '品种',
    dataIndex: 'kindName'
  },
  {
    title: '产地',
    dataIndex: 'producerName'
  },
  {
    title: '数量',
    dataIndex: 'saleableWeight'
  },
  {
    title: '发布价格',
    dataIndex: 'publishPrice'
  },
  {
    title: '有效时间',
    dataIndex: 'validDate'
  },
  {
    title: '交货地点',
    dataIndex: 'deliveryPlaceName'
  }
]

const searchForm: ListingTableProps['searchForm'] = {
  name: 'listingListSearchForm',
  schema: [
    {
      name: 'search',
      type: 'string',
      'x-component': Input,
      'x-component-props': {
        placeholder: '请输入资源ID关键字'
      }
    },
    {
      name: '[validStartDate,validEndDate]',
      type: 'array',
      'x-component': DateRangePicker,
      'x-component-props': {
        placeholder: ['有效开始日期', '有效结束日期']
      }
    }
  ]
}

export const ListingTable = () => {
  const profileId = useAuthStore(state => state.profileId)

  const { pickerListing, setPickerListing } = useListingPickerStore(state =>
    pick(state, ['pickerListing', 'setPickerListing'])
  )

  const id = pickerListing?.id
  const selectedRowKeys = useMemo(() => toArray(id), [id])

  const onSelect = (value?: ListingEntity, selected?: boolean) => {
    const pickerValue = selected ? value : undefined
    setPickerListing(pickerValue)
  }

  return (
    <RemoteTable
      api={queryListingPageApi}
      columns={columns}
      rowKey='id'
      searchForm={searchForm}
      requestParams={{
        creatorProfileId: profileId
      }}
      rowSelection={{
        selectedRowKeys,
        type: 'checkbox',
        hideSelectAll: true,
        onSelect: onSelect
      }}
    />
  )
}
